import { useState } from "react";

// Import the SearchTabs component to allow the user to switch between the MPAN, Address, and MSN search tabs.
import SearchTabs from "../electralink/SearchTabs";

// Import the MpanSearch component to allow the user to fetch meter details using an MPAN.
import AddressSearch from "./AddressSearch";
import MpanSearch from "./MpanSearch";
// Import the AddressSearch component to allow the user to fetch meter details using a postcode.
// Import the MsnSearch component to allow the user to fetch meter details using MSN and postcode.
import MsnSearch from "./MsnSearch";

const electralinkApiStatusUrl = "https://www.electralink.co.uk/service-status/";

const ElectralinkMeterSearch: React.FC = () => {
  // ActiveTab tracks whether the user is searching by MPAN, postcode, or MSN to dynamically render the relevant component. The default rendered component is the 'mpan' search tab.
  // The TS type of <'mpan' | 'address' | 'msn'> ensures that the activeTab useState is strictly limited to these three values to prevent invalid values.
  const [activeTab, setActiveTab] = useState<"mpan" | "address" | "msn">("mpan");

  return (
    <div>
      <h1 data-testid="electralink-meter-search-heading">Electralink Meter Search</h1>
      <div className="meter-search-container">
        {/* Render the SearchTabs component with the active tab state and change handler to allow the user to switch between MPAN, address, and MSN search. */}
        <SearchTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {/* Each search component is always mounted to retain state across tab switches. The Bootstrap 'd-none' class (display: none) hides the inactive tabs. */}
        <div className={activeTab !== "mpan" ? "d-none" : ""}>
          <MpanSearch />
        </div>
        <div className={activeTab !== "address" ? "d-none" : ""}>
          <AddressSearch />
        </div>
        <div className={activeTab !== "msn" ? "d-none" : ""}>
          <MsnSearch />
        </div>

        <a
          href={electralinkApiStatusUrl}
          target="_blank"
          rel="noreferrer"
          className="electralink-api-status-link"
        >
          Not getting results? Click here to check if Electralink is down.
        </a>
      </div>
    </div>
  );
};

export default ElectralinkMeterSearch;
